/**
 * @generated SignedSource<<2cf28df69801d2e8d4ca1f516b897779>>
 * @relayHash 4242efb1e1867c214b21bde3f239c032
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type groupJqlBuilderBasicInitQuery$variables = {
  cloudId: string;
};
export type groupJqlBuilderBasicInitQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly suggestedGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type groupJqlBuilderBasicInitQuery = {
  response: groupJqlBuilderBasicInitQuery$data;
  variables: groupJqlBuilderBasicInitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlBuilder",
      "kind": "LinkedField",
      "name": "jqlBuilder",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "context",
              "value": "GROUP"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }
          ],
          "concreteType": "JiraJqlGroupFieldValueConnection",
          "kind": "LinkedField",
          "name": "suggestedGroups",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraJqlGroupFieldValueEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraJqlGroupFieldValue",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jqlTerm"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "suggestedGroups(context:\"GROUP\",first:10)"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "groupJqlBuilderBasicInitQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v1/*: any*/),
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "groupJqlBuilderBasicInitQuery",
    "selections": [
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d",
    "metadata": {},
    "name": "groupJqlBuilderBasicInitQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "89effe1db6e447cbb0e66d80074d1b0b";

export default node;
